export const joinPaths = (basePath: string, ...paths: string[]) =>
  paths.reduce((acc, curr) => {
    acc = acc.endsWith('/') ? acc.slice(0, -1) : acc
    curr = curr.startsWith('/') ? curr.slice(1) : curr
    return `${acc}/${curr}`
  }, basePath)
